import axios from "axios";
import { BASE_URL, SUB_URL_dispatch_center } from "../BaseUrl";

const ManageBinService ={

    getBinDatabyBinId : async (bin_id) => {
      try {
        const formValue = new FormData();
        formValue.append('bin_id', bin_id);

        const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_dispatch_center.getBinByBinId}`, formValue);        
        return response.data;
      } catch (error) {
        console.error(error);
      }  
    },

    BulkOutward : async (bin_ids, added_by) => {
      console.log("BulkOutward", JSON.stringify(bin_ids), added_by);
      
        try {
            const formValue = new FormData();
            formValue.append('bin_ids', JSON.stringify(bin_ids));
            formValue.append('added_by', added_by);

            for (let pair of formValue.entries()) {
              console.log(`${pair[0]}: ${pair[1]}`);
          }

            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_dispatch_center.bin_bulk_outward}`, formValue);
            console.log(response.data);
            return response.data;
        } catch (error) {
            console.error("Failed to bulk outward",error);
            
        }
    },
    getBulkBinData : async (bin_ids) => {
      console.log("get bin Outward data", bin_ids);
      
        try {
            const formValue = new FormData();
            formValue.append('bin_id', JSON.stringify(bin_ids));

            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_dispatch_center.getBulkBindata}`, formValue);
            return response.data;
        } catch (error) {
            console.error("Failed to bulk outward",error);
            
        }
    }
};

export default ManageBinService;